import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import SafraConsulta from 'entity/Safra/components/SafraConsulta'
import SafraForm from 'entity/Safra/components/SafraForm'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-safra"
                route="consulta-safra"

                menuProps={{
                    text: "Safras",
                    sequence: "111114",
                    iconName: "Sync",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<SafraConsulta />}
            />
            <BasicRoute
                uid="safra"
                route="_safra"
                element={<SafraForm />}
            />
        </>
    )
}
